import { relate } from '/app/utils/relationships';

export const relationships = (axios, { fields, debug = false } = {}) => {
    axios.interceptors.response.use(relate(fields, {
        beforeRelate: (data) => data.relationships || data.relationship,
        debug,
    }))
}